import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchTemplates } from '../../api/templatesApi';
import { toSavedTask, sortSavedTasks } from '../home/homeData';

export function useSavedTasks() {
  const [state, setState] = useState({ loading: true, error: false, tasks: [] });
  const mounted = useRef(true);

  const load = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: false }));
    try {
      const templates = await fetchTemplates(null, false);
      if (!mounted.current) return;
      const tasks = sortSavedTasks(
        (templates || []).filter((t) => t.template_class !== 'starter').map(toSavedTask)
      );
      setState({ loading: false, error: false, tasks });
    } catch (e) {
      if (mounted.current) setState({ loading: false, error: true, tasks: [] });
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    load();
    return () => { mounted.current = false; };
  }, [load]);

  return { ...state, reload: load };
}
